import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPictoPartCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1206_9)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M11.9606 34.4996C11.3263 33.8323 11.3263 32.7503 11.9606 32.083L37.2273 5.50059C37.8616 4.83327 38.89 4.83327 39.5243 5.50059C40.1586 6.16791 40.1586 7.24985 39.5243 7.91717L14.2576 34.4996C13.6233 35.1669 12.5949 35.1669 11.9606 34.4996Z",
			fill: "#0071CC"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M14.2576 34.4996C13.6233 35.1669 12.5949 35.1669 11.9606 34.4996L0.475719 22.4167C-0.158573 21.7494 -0.158573 20.6674 0.475719 20.0001C1.11001 19.3328 2.1384 19.3328 2.77269 20.0001L14.2576 32.083C14.8919 32.7503 14.8919 33.8323 14.2576 34.4996Z",
			fill: "#0071CC"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1206_9",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgPictoPartCheck;
